var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.textClass.join(' '),style:(_vm.style)},[_c('p',[_vm._v(" "+_vm._s(_vm.haveContents(_vm.data))+" "),_vm._l((_vm.data.contents),function(content,index){return _c('flex-span',{key:index,attrs:{"data":content}})})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }